import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: "anglo-google-dialog",
  templateUrl: "./GoogleDialog.component.html",
  styleUrls: ["./GoogleDialog.component.scss"],
})
export class GoogleDialogComponent implements OnInit {
  public libCancelBtn;
  public libConfirmBtn; 
  constructor(
    public dialogRef: MatDialogRef<GoogleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data) {
      this.libCancelBtn = this.data.libCancelBtn
        ? this.data.libCancelBtn
        : "Annuler";
      this.libConfirmBtn = this.data.libConfirmBtn
        ? this.data.libConfirmBtn
        : "Confirmer";
    }
  }

  ngOnInit() {}
}
